import React, { useEffect, useContext } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './Products.css';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';

function Products() {
    const navigate = useNavigate();
    const { language } = useContext(LanguageContext);

    useEffect(() => {
        const adjustMarginTop = () => {
            const header = document.querySelector('.App-header');
            const container = document.querySelector('.products-container');
            if (header && container) {
                const headerHeight = header.offsetHeight;
                container.style.marginTop = `${headerHeight}px`;
            }
        };

        // Adjust margin on initial load
        adjustMarginTop();

        // Adjust margin on window resize
        window.addEventListener('resize', adjustMarginTop);

        return () => window.removeEventListener('resize', adjustMarginTop);
    }, []);

    const products = [
        {
            id: 1,
            image: '/images/technician.jpg',
            title: 'Maestro',
            description: language === 'en' ? 'Maintenance, Repair, Material and Fixture Management' : 'Bakım, Onarım, Malzeme ve Ekipman Yönetimi'
        },
        {
            id: 2,
            image: '/images/labor.jpg',
            title: 'Hazmat',
            description: language === 'en' ? 'Hazardous Substances Inventory' : 'Tehlikeli Maddeler Envanteri'
        },
        {
            id: 3,
            image: '/images/map.jpg',
            title: 'IBoard',
            description: language === 'en' ? 'Info Board(Direction and Location Finding System)' : 'Bilgi Panosu(Yön ve Konum Bulma Sistemi)'
        },
        {
            id: 4,
            image: '/images/apartment.jpg',
            title: language === 'en' ? 'Building and Resident Management System' : 'Site Yönetim Yazılımı',
            description: language === 'en' ? 'Streamline apartment management with our comprehensive system.' : 'Kapsamlı sistemimizle apartman yönetimini kolaylaştırın.'
        },
    ];

    const renderProducts = () => {
        const productPairs = [];
        for (let i = 0; i < products.length; i += 2) {
            productPairs.push(products.slice(i, i + 2));
        }

        const handleLearnMore = (product) => {
            navigate(`/products/${product.title}`);
        };

        return productPairs.map((pair, index) => (
            <Carousel.Item key={index}>
                <div className="row justify-content-center">
                    {pair.map((product, idx) => (
                        <div className="col-md-4" key={idx}>
                            <div className="card mb-4 shadow-sm">
                                <img src={product.image} className="card-img-top" alt={product.title} />
                                <div className="card-body">
                                    <h5 className="card-title">{product.title}</h5>
                                    <p className="card-text">{product.description}</p>
                                    <button
                                        className="btn btn-primary"
                                        onClick={product.id === 1 ? () => handleLearnMore(product) : undefined}
                                        style={{ backgroundColor: product.id === 1 ? undefined : '#671818' }}
                                    >
                                        {product.id === 1 ? (language === 'en' ? 'Learn More' : 'Daha Fazla Bilgi') : (language === 'en' ? 'Under Construction' : 'Yapım Aşamasında')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Carousel.Item>
        ));
    };

    return (
        <div className="products-page">
            <main className="products-container">
                <h1 className="display-4 text-center my-5">{language === 'en' ? 'Our Products' : 'Ürünlerimiz'}</h1>
                <Carousel>{renderProducts()}</Carousel>
            </main>
        </div>
    );
}

export default Products;
